module.exports = __webpack_public_path__ + "static/media/iphone-img-mental.07a4b80a.svg";